import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'freenics-coverletter',
  templateUrl: './freenics.coverletter.component.pug',
  styleUrls: ['./freenics.coverletter.component.styl']
})
export class FreenicsCoverletterComponent implements OnInit {

	public constructor(private titleService: Title) { }
  
	title: string;
	subtitle: string;
	tirtitle: string;
	company: string;

	ngOnInit() {
		this.title='Freenics';
		this.subtitle='Human Resources';
		this.titleService.setTitle("Liam Hogan's Cover Letter");
		this.tirtitle='';
		this.company='Freenics';
	}

}
